import { axiosInstance } from "../core/http";

export const clientVideosApi = {
  getAll: (page = 1) =>
    axiosInstance.get("/panel/client-video/list/", { params: { page } }),
  getS3UploadUrl: (client_video_id) =>
    axiosInstance.post("/panel/client-video/upload/local/", {
      client_video_id,
    }),
  createVideoWithUrl: (video_url, client_video_id) =>
    axiosInstance.post("/panel/client-video/upload/remote/", {
      video_url,
      client_video_id,
    }),
  cutAndCreate: (
    videoId,
    start,
    end,
    pipelinePassing,
    leftSideJerseyColor,
    rightSideJerseyColor,
    matchTime
  ) =>
    axiosInstance.post(`/panel/client-video/${videoId}/cut/`, {
      time_ranges: [{ start, end }],
      pipeline_passing: pipelinePassing,
      left_side_jersey_color: leftSideJerseyColor,
      right_side_jersey_color: rightSideJerseyColor,
      ...(typeof matchTime !== "undefined" && matchTime !== null
        ? { match_time: matchTime }
        : {}),
    }),
  markVideoAsLoaded: (client_video_id) =>
    axiosInstance.post(`/panel/client-video/${client_video_id}/is_loaded/`),
  initMultipartUpload: (client_video_id) =>
    axiosInstance.post("/panel/client-video/upload/local-multipart/init/", {
      client_video_id,
    }),
  getMultipartUploadUrl: (storage_file, upload_id, part_number) =>
    axiosInstance.post("/panel/client-video/upload/local-multipart/part/", {
      storage_file,
      upload_id,
      part_number,
    }),
  completeMultipartUpload: (storage_file, upload_id, parts) =>
    axiosInstance.post("/panel/client-video/upload/local-multipart/complete/", {
      storage_file,
      upload_id,
      parts,
    }),
  abortMultipartUpload: (storage_file, upload_id) =>
    axiosInstance.post("/panel/client-video/upload/local-multipart/abort/", {
      storage_file,
      upload_id,
    }),
  reloadVideo: (client_video_id) =>
    axiosInstance.post(`/panel/client-video/${client_video_id}/reload`),
  reencodeVideo: (client_video_id) =>
    axiosInstance.post(`/panel/client-video/${client_video_id}/reencode`),
};
